import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ScaleIcon, BookOpenIcon, MessageCircleIcon } from 'lucide-react';
export function FailedSolutions() {
  const solutions = [{
    icon: <ScaleIcon className="w-8 h-8 text-terracotta" data-id="element-14" />,
    title: 'Testamentos Legales',
    description: 'Son fríos, costosos y no dicen dónde guardó usted la llave del candado o la clave de su iPad.'
  }, {
    icon: <BookOpenIcon className="w-8 h-8 text-terracotta" data-id="element-15" />,
    title: 'Libros de 300 páginas',
    description: 'Son tan abrumadores que terminan guardados en un cajón sin estrenar.'
  }, {
    icon: <MessageCircleIcon className="w-8 h-8 text-terracotta" data-id="element-16" />,
    title: 'Cenas Familiares',
    description: "Intentar explicarlo todo suele terminar en 'no hablemos de eso ahora, mamá', y la información se pierde."
  }];
  return <section className="py-20 md:py-32 px-6 bg-cream" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-16 text-center" data-id="element-20">
            Por qué lo que ha intentado hasta ahora no funciona
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-21">
          {solutions.map((solution, index) => <FadeIn key={index} delay={0.2 + index * 0.1} className="h-full" data-id="element-22">
              <div className="bg-card rounded-2xl p-8 shadow-warm h-full border border-sage/5 flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300" data-id="element-23">
                <div className="w-16 h-16 rounded-full bg-terracotta/10 flex items-center justify-center mb-6" data-id="element-24">
                  {solution.icon}
                </div>
                <h3 className="font-serif text-xl text-charcoal font-semibold mb-4" data-id="element-25">
                  {solution.title}
                </h3>
                <p className="text-muted leading-relaxed" data-id="element-26">
                  {solution.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}